import styled from 'styled-components';

const StyledBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.zIndex.modal};
`;

const StyledDialog = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: 12px 12px 50px ${({ theme }) => theme.colors.modalShadow};
  width: 80vw;
  max-width: 900px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderMuted};
`;

const StyledTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 700;
`;

const StyledBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 1rem;
`;

const StyledTextarea = styled.textarea<{ $hasError: boolean }>`
  flex: 1;
  font-family: monospace;
  font-size: 13px;
  resize: none;
  padding: 0.75rem;
  border: ${({ $hasError, theme }) =>
    $hasError ? `1.5px solid ${theme.colors.dangerText}` : `1px solid ${theme.colors.borderMuted}`};
  border-radius: ${({ theme }) => theme.radii.sm};
  background: ${({ theme }) => theme.colors.surfaceMuted};
  line-height: 1.5;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.625rem;
  padding: 0.875rem 1.25rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderMuted};
`;

/**
 * Wrapper around the shared <ErrorMessage> inside the JSON editor body.
 * Contributes spacing + slightly larger padding/font tuned to the wider
 * modal dialog. Targets the inner alert via [role='alert'] so we don't
 * couple ErrorMessage to this one use site.
 */
const StyledJsonErrorSlot = styled.div`
  margin-top: 0.5rem;

  > [role='alert'] {
    padding: 0.5rem 0.75rem;
    font-size: 13px;
  }
`;

export default {
  StyledBackdrop,
  StyledDialog,
  StyledHeader,
  StyledTitle,
  StyledBody,
  StyledTextarea,
  StyledFooter,
  StyledJsonErrorSlot,
};
